import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Paper,
  Grid,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
  Divider,
  CircularProgress,
  Snackbar,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  TextField,
  Checkbox,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Chip,Container,Stack,Tooltip
} from "@mui/material";
import { 
  ArrowBack as ArrowBackIcon, 
  Add as AddIcon, 
  Delete as DeleteIcon,
  Warning as WarningIcon,
  Edit as EditIcon,
  AutoAwesome as SparklesIcon,
  Psychology as PsychologyIcon,
  TrendingUp as TrendingUpIcon,
  Info as InfoIcon
} from "@mui/icons-material";
import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const TeamAllocation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [teams, setTeams] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState("");
  const [teamMembers, setTeamMembers] = useState([]);
  const [selectedTeamMembers, setSelectedTeamMembers] = useState([]);
  const [teamData, setTeamData] = useState({
    selectedProject: "",
    assignedMembers: [],
  });
  const [aiRecommendations, setAiRecommendations] = useState(null);
const [loadingRecommendations, setLoadingRecommendations] = useState(false);
const [showRecommendations, setShowRecommendations] = useState(false);
const [selectedRecommendations, setSelectedRecommendations] = useState([]);

  // New state to track all loaded team members across all teams
  const [allTeamMembers, setAllTeamMembers] = useState({});

  const [projects, setProjects] = useState([]);
  const [selectedProjectData, setSelectedProjectData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [isLoadingExistingData, setIsLoadingExistingData] = useState(false);
  
  // State for delete confirmation dialog
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [memberToDelete, setMemberToDelete] = useState(null);

// Add these new state variables after your existing state declarations
const [employees, setEmployees] = useState([]);
const [employeeMap, setEmployeeMap] = useState({});
       const [employeeId, setEmployeeId] = useState(null);

    const getEmployeeid = async () => {
    try {
       const token = localStorage.getItem('token');
    if (!token) {
      alert("No authentication token found. Please log in.");
      return;
    }
  
    const payload = JSON.parse(atob(token.split('.')[1]));
    const company_id = payload.company_id;
      const response = await axios.get(`${API_URL}/api/user/current?company_id=${company_id}`, {
        withCredentials: true
      });

      if (!response.data || !response.data.employee_id) {
        alert('Session Expired, Please login again')
        throw new Error('Employee ID not found in user data');
      }

      setEmployeeId(response.data.employee_id);
      
      return response.data.employee_id;
    } catch (err) {
      setErrors('Failed to fetch user information');
      return null;
    }
  };

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        
    const token = localStorage.getItem('token');
    if (!token) {
      alert("No authentication token found. Please log in.");
      return;
    }
  
    const payload = JSON.parse(atob(token.split('.')[1]));
    const company_id = payload.company_id;
        const employee_ids= await getEmployeeid();

        // Fetch active projects
        const projectsResponse = await axios.get(`${API_URL}/api/addteam/project/active?employee_id=${employee_ids}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setProjects(projectsResponse.data);

        // Fetch teams for manager
        const teamsResponse = await axios.get(`${API_URL}/api/addteam/members/teams?employee_id=${employee_ids}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setTeams(teamsResponse.data.teams || []);
        
        const employeesResponse = await axios.get(`${API_URL}/api/addteam/employees?employee_id=${employee_ids}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      setEmployees(employeesResponse.data || []);
         const empMap = {};
      employeesResponse.data.forEach(emp => {
        empMap[emp.employee_id] = emp; // Adjust field names as per your API
      });
      setEmployeeMap(empMap);
      } catch (error) {
        showSnackbar(error.response?.data?.message || "An error occurred while loading data", "error");
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  // const fetchAIRecommendations = async () => {
  //   if (!teamData.selectedProject) {
  //     showSnackbar("Please select a project first", "warning");
  //     return;
  //   }
  
  //   if (!selectedTeam) {
  //     showSnackbar("Please select a team first", "warning");
  //     return;
  //   }
  
  //   setLoadingRecommendations(true);
  //   try {
  //     const token = localStorage.getItem('token');
  //     if (!token) {
  //       showSnackbar("Authentication required", "error");
  //       return;
  //     }
  
  //     const payload = JSON.parse(atob(token.split('.')[1]));
  //     const company_id = payload.company_id;
  
  
  //     const response = await axios.get(
  //       `${API_URL}/api/addteam/ai-recommendations/${teamData.selectedProject}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  
  
  //     // Validate response structure
  //     if (!response.data) {
  //       throw new Error("Empty response from AI service");
  //     }
  
  //     setAiRecommendations(response.data);
  //     setShowRecommendations(true);
      
  //     const recCount = response.data.recommendations?.length || 0;
  //     showSnackbar(
  //       `AI generated ${recCount} recommendation(s) successfully!`, 
  //       "success"
  //     );
  //   } catch (error) {
  //     showSnackbar(
  //       error.response?.data?.message || "Failed to generate recommendations. Please try again.",
  //       "error"
  //     );
  //   } finally {
  //     setLoadingRecommendations(false);
  //   }
  // };
  
  // Fixed applyAIRecommendations function
  const applyAIRecommendations = () => {
    if (selectedRecommendations.length === 0) {
      showSnackbar("Please select at least one recommendation", "warning");
      return;
    }
  
    if (!selectedTeam) {
      showSnackbar("Please select a team first", "warning");
      return;
    }
  
    const newMembers = selectedRecommendations.map(rec => {
      // Calculate safe allocation (don't exceed available)
      const safeAllocation = Math.min(
        rec.suggested_allocation || 100,
        rec.available_allocation || 100,
        100
      );
  
      return {
        employeeId: rec.employee_id,
        teamId: selectedTeam,
        role: rec.suggested_role || rec.designation || "Developer",
        allocation: safeAllocation,
        startDate: selectedProjectData?.start_date || new Date().toISOString().split("T")[0],
        endDate: selectedProjectData?.end_date || "",
        isExisting: false,
        isProductOwner: false
      };
    });
  
    // Filter out already assigned members
    const alreadyAssignedIds = teamData.assignedMembers.map(m => m.employeeId);
    const uniqueNewMembers = newMembers.filter(
      m => !alreadyAssignedIds.includes(m.employeeId)
    );
  
    if (uniqueNewMembers.length === 0) {
      showSnackbar("All selected members are already assigned to this project", "info");
      return;
    }
  
    if (uniqueNewMembers.length < selectedRecommendations.length) {
      const skipped = selectedRecommendations.length - uniqueNewMembers.length;
      showSnackbar(
        `Added ${uniqueNewMembers.length} member(s). ${skipped} already assigned.`,
        "info"
      );
    } else {
      showSnackbar(`Added ${uniqueNewMembers.length} AI-recommended member(s)`, "success");
    }
  
    setTeamData(prev => ({
      ...prev,
      assignedMembers: [...prev.assignedMembers, ...uniqueNewMembers]
    }));
  
    setSelectedRecommendations([]);
    setShowRecommendations(false);
  };
  
 

  useEffect(() => {
    if (location.state?.selectedProjectId) {
      setTeamData((prev) => ({
        ...prev,
        selectedProject: location.state.selectedProjectId,
      }));

      const project = projects.find((p) => p.project_id === location.state.selectedProjectId);
      if (project) {
        setSelectedProjectData(project);
        loadExistingTeamData(location.state.selectedProjectId);
      }
    }
  }, [location.state, projects]);

  const showSnackbar = (message, severity = "success") => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };


  // Add this helper function before your useEffect hooks
const getEmployeeNameById = (employeeId) => {
  const employee = employeeMap[employeeId];
  return employee ? `${employee.name}` : employeeId;
};
  // Function to load existing team allocation data for a project
  const loadExistingTeamData = async (projectId) => {
    setIsLoadingExistingData(true);
    try {
      
    const token = localStorage.getItem('token');
    if (!token) {
      alert("No authentication token found. Please log in.");
      return;
    }
  
    const payload = JSON.parse(atob(token.split('.')[1]));
    const company_id = payload.company_id;
      const response = await axios.get(`${API_URL}/api/addteam/project/${projectId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      
      if (response.data && response.data.teamMembers && response.data.teamMembers.length > 0) {
        // Set the selected team if it exists
        if (response.data.teamId) {
          setSelectedTeam(response.data.teamId);
          
          // Load team members for this team
          await loadTeamMembers(response.data.teamId);
        }
        
        // Format and set assigned members
        const formattedMembers = response.data.teamMembers.map(member => ({
          employeeId: member.employee_id,
          teamMemberId: member.team_member_id,
          // Ensure teamId is always set from the member's actual team_id
          teamId: member.teamId, 
          role: member.role || "Developer",
          allocation: member.allocation|| 100,
          startDate: member.start_date || selectedProjectData?.start_date,
          endDate: member.end_date || selectedProjectData?.end_date,
          isExisting: true,
          isProductOwner: selectedProjectData?.lead_id === member.employee_id
        }));
        
        setTeamData(prev => ({
          ...prev,
          assignedMembers: formattedMembers
        }));
      }
    } catch (error) {
      if (error.response?.status !== 404) {
        showSnackbar("Failed to load existing team data for this project", "error");
      }
    } finally {
      setIsLoadingExistingData(false);
    }
  };

  const loadTeamMembers = async (teamId) => {
    try {
      
    const token = localStorage.getItem('token');
    if (!token) {
      alert("No authentication token found. Please log in.");
      return;
    }
  
    const payload = JSON.parse(atob(token.split('.')[1]));
    const company_id = payload.company_id;
      const empId = employeeId || await getEmployeeid();
      const empQuery = empId ? `?employee_id=${empId}` : '';
      const response = await axios.get(`${API_URL}/api/addteam/teams/${teamId}/members${empQuery}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const membersWithTeamId = (response.data.members || []).map(member => ({
        ...member,
        team_id: teamId  // Add the teamId explicitly to each member
      }));
      
      // Store these members in both the current team members state and the all team members state
      setTeamMembers(membersWithTeamId);
      
      // Add to the allTeamMembers map, keyed by teamId
      setAllTeamMembers(prev => ({
        ...prev,
        [teamId]: membersWithTeamId
      }));
    } catch (error) {
    }
  };
  
  const handleEditMember = (member) => {
    navigate("/createteam", {
      state: { 
        isEditing: true,
        teamId: member.teamId || selectedTeam, // Use the member's specific team ID
        teamName: teams.find(t => t.team_id === (member.teamId || selectedTeam))?.team_name || "",
        memberId: member.employeeId,
        memberRole: member.role,
        projectId: teamData.selectedProject
      }
    });
  };

  const handleProjectChange = (e) => {
    const { value } = e.target;
    const project = projects.find((p) => p.project_id === value);

    setSelectedProjectData(project);
    
    // Reset form data before loading new project data
    setTeamData({
      selectedProject: value,
      assignedMembers: [],
    });
    setSelectedTeam("");
    setTeamMembers([]);
    
    // Load existing team data for this project
    loadExistingTeamData(value);

    if (errors.selectedProject) {
      setErrors({
        ...errors,
        selectedProject: "",
      });
    }
  };

  const handleTeamChange = async (e) => {
    const { value } = e.target;
    setSelectedTeam(value);

    // Check if we've already loaded this team's members
    if (allTeamMembers[value]) {
      setTeamMembers(allTeamMembers[value]);
    } else {
      try {
        await loadTeamMembers(value);
      } catch (error) {
        showSnackbar(error.response?.data?.message || "An error occurred while loading team members", "error");
      }
    }
  };

  const handleTeamMemberSelect = (memberId) => {
    setSelectedTeamMembers((prev) =>
      prev.includes(memberId) ? prev.filter((id) => id !== memberId) : [...prev, memberId]
    );
  };

  const handleAddSelectedTeamMembers = () => {
    // Filter out members that are already assigned
    const alreadyAssignedIds = teamData.assignedMembers.map(member => member.employeeId);
    
    // Find the actual team member objects from the current team members list
    const selectedMemberObjects = teamMembers.filter(member => 
      selectedTeamMembers.includes(member.employee_id) && 
      !alreadyAssignedIds.includes(member.employee_id)
    );
    
    // Create new member objects with teamId properly assigned
    const newMembers = selectedMemberObjects.map(member => ({
      employeeId: member.employee_id,
      teamId: member.team_id,  // Preserve the original team_id
      role: member.role || "Developer",
      allocation: 100,
      startDate: selectedProjectData?.start_date || new Date().toISOString().split("T")[0],
      endDate: selectedProjectData?.end_date || new Date().toISOString().split("T")[0],
      isExisting: false,
      isProductOwner: false
    }));

    setTeamData(prev => ({
      ...prev,
      assignedMembers: [...prev.assignedMembers, ...newMembers],
    }));

    setSelectedTeamMembers([]);
  };

  // Open confirmation dialog before deleting
  const handleDeleteMemberClick = (member) => {
    setMemberToDelete(member);
    setDeleteDialogOpen(true);
  };

  // Close confirmation dialog
  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setMemberToDelete(null);
  };

  // Handle removing team member from UI only
  const handleRemoveMemberFromUI = (userId) => {
    setTeamData((prev) => ({
      ...prev,
      assignedMembers: prev.assignedMembers.filter((member) => member.employeeId !== userId),
    }));
  };

  // Handle deleting team member from database
  const handleDeleteMemberFromDB = async () => {
    if (!memberToDelete || !memberToDelete.teamMemberId) {
      handleCloseDeleteDialog();
      return;
    }

    setDeleting(true);
    try {
      
    const token = localStorage.getItem('token');
    if (!token) {
      alert("No authentication token found. Please log in.");
      return;
    }
  
    const payload = JSON.parse(atob(token.split('.')[1]));
    const company_id = payload.company_id;
      await axios.delete(`${API_URL}/api/addteam/team-members/${memberToDelete.teamMemberId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      
      // Remove from UI after successful deletion
      handleRemoveMemberFromUI(memberToDelete.employeeId);
      
      showSnackbar("Team member removed successfully", "success");
    } catch (error) {
      showSnackbar(
        error.response?.data?.message || "Failed to remove team member", 
        "error"
      );
    } finally {
      setDeleting(false);
      handleCloseDeleteDialog();
    }
  };

  // Main handler for removing a member - determines if it's a DB delete or just UI remove
  const handleRemoveMember = (member) => {
    if (member.isExisting && member.teamMemberId) {
      // If it's an existing record in the database, prompt for confirmation
      handleDeleteMemberClick(member);
    } else {
      // If it's just a new record not yet saved, just remove from UI
      handleRemoveMemberFromUI(member.employeeId);
    }
  };

  const handleMemberFieldChange = (employeeId, field, value) => {
    setTeamData({
      ...teamData,
      assignedMembers: teamData.assignedMembers.map((member) => {
        if (member.employeeId === employeeId) {
          return { ...member, [field]: value };
        }
        return member;
      }),
    });
  };

  // Handle product owner selection - ensures only one can be selected
  const handleProductOwnerChange = (employeeId, checked) => {
    // Update all team members
    const updatedMembers = teamData.assignedMembers.map(member => {
      // If this is the member we're updating, set isProductOwner to the new value
      if (member.employeeId === employeeId) {
        return { ...member, isProductOwner: checked };
      }
      // If this is another member and we're checking the current member, uncheck this one
      else if (checked) {
        return { ...member, isProductOwner: false };
      }
      // Otherwise keep the current value
      return member;
    });

    setTeamData(prev => ({
      ...prev,
      assignedMembers: updatedMembers
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!teamData.selectedProject) {
      newErrors.selectedProject = "Please select a project";
    }

    if (teamData.assignedMembers.length === 0) {
      newErrors.assignedMembers = "Please assign at least one team member";
    }
    
    // Check if all members have a valid teamId
    const membersWithoutTeam = teamData.assignedMembers.filter(member => !member.teamId);
    if (membersWithoutTeam.length > 0) {
      newErrors.team = "Some members don't have a team assigned";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const formatTeamData = () => {
    // Lead ID comes from the project's designated Product Owner
    const leadId = selectedProjectData?.product_owner_id || null;

    return {
      projectId: teamData.selectedProject,
      teamId: selectedTeam, // This is only used for displaying the current selection
      leadId: leadId,
      teamMembers: teamData.assignedMembers.map(member => ({
        employeeId: member.employeeId,
        teamId: member.teamId, // Keep the member's specific team ID
        role: member.role,
        allocation: member.allocation,
        startDate: member.startDate,
        endDate: member.endDate,
        // Include the team_member_id for existing records
        team_member_id: member.teamMemberId || undefined,
        isProductOwner: false
      })),
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!validateForm()) {
      return;
    }
  
    // Make sure all members have teamId set
    const membersWithoutTeamId = teamData.assignedMembers.filter(member => !member.teamId);
    if (membersWithoutTeamId.length > 0) {
      showSnackbar("Some team members don't have a team assigned. Please check and try again.", "error");
      return;
    }
  
    const formattedData = formatTeamData();
  
    try {
      setSaving(true);
  
      // Extract company_id from token
      const token = localStorage.getItem('token');
      if (!token) {
        alert("No authentication token found. Please log in.");
        return;
      }
      const payload = JSON.parse(atob(token.split('.')[1]));
      const company_id = payload.company_id;
  
      // Send company_id via req.query
      await axios.post(`${API_URL}/api/addteam`, formattedData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      navigate("/manageteam", {
        state: { message: "Team updated successfully!", severity: "success" },
      });
    } catch (error) {
      showSnackbar(
        error.response?.data?.message || "An error occurred while updating the team", 
        "error"
      );
    } finally {
      setSaving(false);
    }
  };
  

  const dateConstraints = {
    min: selectedProjectData?.start_date || null,
    max: selectedProjectData?.end_date || null,
  };

  // Helper function to get team name by team ID
  const getTeamNameById = (teamId) => {
    const team = teams.find(t => t.team_id === teamId);
    return team ? team.team_name : "Unknown Team";
  };

  const AIRecommendationsDialog = () => {
    const hasRecommendations = aiRecommendations?.recommendations?.length > 0;
    const hasAnalysis = aiRecommendations?.team_analysis;
  
    return (
      <Dialog 
        open={showRecommendations} 
        onClose={() => setShowRecommendations(false)} 
        maxWidth="lg" 
        fullWidth
      >
        <DialogTitle sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          bgcolor: 'primary.main', 
          color: 'white' 
        }}>
          <SparklesIcon sx={{ mr: 1 }} />
          AI Team Recommendations
          {aiRecommendations?.projectDetails && (
            <Typography variant="subtitle2" sx={{ ml: 2, opacity: 0.9 }}>
              for {aiRecommendations.projectDetails.name}
            </Typography>
          )}
        </DialogTitle>
        
        <DialogContent sx={{ mt: 2 }}>
          {!aiRecommendations ? (
            <Box display="flex" justifyContent="center" p={3}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              {/* Team Analysis Section */}
              {hasAnalysis && (
                <Paper 
                  elevation={2} 
                  sx={{ 
                    p: 2, 
                    mb: 3, 
                    bgcolor: 'info.light', 
                    border: '1px solid',
                    borderColor: 'info.main'
                  }}
                >
                  <Box display="flex" alignItems="center" mb={2}>
                    <PsychologyIcon sx={{ mr: 1 }} />
                    <Typography variant="h6">Team Analysis</Typography>
                  </Box>
  
                  {aiRecommendations.team_analysis.current_gaps?.length > 0 && (
                    <Box mb={2}>
                      <Typography variant="subtitle2" gutterBottom fontWeight="bold">
                        Identified Skill Gaps:
                      </Typography>
                      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                        {aiRecommendations.team_analysis.current_gaps.map((gap, idx) => (
                          <Chip 
                            key={idx} 
                            label={gap} 
                            size="small" 
                            color="warning" 
                            icon={<WarningIcon />}
                            sx={{ mb: 1 }}
                          />
                        ))}
                      </Stack>
                    </Box>
                  )}
  
                  {aiRecommendations.team_analysis.team_size_recommendation && (
                    <Typography variant="body2" paragraph>
                      <strong>Team Size Recommendation:</strong>{' '}
                      {aiRecommendations.team_analysis.team_size_recommendation}
                    </Typography>
                  )}
  
                  {aiRecommendations.team_analysis.additional_notes && (
                    <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                      <strong>Additional Notes:</strong>{' '}
                      {aiRecommendations.team_analysis.additional_notes}
                    </Typography>
                  )}
                </Paper>
              )}
  
              {/* Recommendations Section */}
              {hasRecommendations ? (
                <>
                  <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="subtitle1" fontWeight="bold">
                      Recommended Team Members ({aiRecommendations.recommendations.length})
                    </Typography>
                    {aiRecommendations.availableEmployees !== undefined && (
                      <Chip 
                        label={`${aiRecommendations.availableEmployees} available`}
                        color="success"
                        size="small"
                      />
                    )}
                  </Box>
  
                  <TableContainer component={Paper} variant="outlined">
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell padding="checkbox">
                            <Checkbox
                              indeterminate={
                                selectedRecommendations.length > 0 &&
                                selectedRecommendations.length < aiRecommendations.recommendations.length
                              }
                              checked={
                                aiRecommendations.recommendations.length > 0 &&
                                selectedRecommendations.length === aiRecommendations.recommendations.length
                              }
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedRecommendations(aiRecommendations.recommendations);
                                } else {
                                  setSelectedRecommendations([]);
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell><strong>Employee</strong></TableCell>
                          <TableCell><strong>Suggested Role</strong></TableCell>
                          <TableCell align="center"><strong>Allocation</strong></TableCell>
                          <TableCell align="center"><strong>Priority</strong></TableCell>
                          <TableCell><strong>Reasoning</strong></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {aiRecommendations.recommendations.map((rec, idx) => {
                          const isSelected = selectedRecommendations.some(
                            r => r.employee_id === rec.employee_id
                          );
                          const isAlreadyAssigned = teamData.assignedMembers.some(
                            m => m.employeeId === rec.employee_id
                          );
  
                          return (
                            <TableRow 
                              key={idx}
                              hover
                              selected={isSelected}
                              sx={{ 
                                bgcolor: isAlreadyAssigned ? 'action.disabledBackground' : 'inherit',
                                opacity: isAlreadyAssigned ? 0.6 : 1
                              }}
                            >
                              <TableCell padding="checkbox">
                                <Checkbox
                                  checked={isSelected}
                                  disabled={isAlreadyAssigned}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedRecommendations([...selectedRecommendations, rec]);
                                    } else {
                                      setSelectedRecommendations(
                                        selectedRecommendations.filter(r => r.employee_id !== rec.employee_id)
                                      );
                                    }
                                  }}
                                />
                              </TableCell>
                              <TableCell>
                                <Box>
                                  <Typography variant="body2" fontWeight="bold">
                                    {rec.employee_name || 'Unknown'}
                                  </Typography>
                                  <Typography variant="caption" color="text.secondary">
                                    {rec.designation || 'No designation'} • {rec.type || 'Employee'}
                                  </Typography>
                                  {isAlreadyAssigned && (
                                    <Chip 
                                      label="Already Assigned" 
                                      size="small" 
                                      color="default"
                                      sx={{ ml: 1, height: 20 }}
                                    />
                                  )}
                                </Box>
                              </TableCell>
                              <TableCell>
                                <Chip 
                                  label={rec.suggested_role || 'Developer'} 
                                  color="primary" 
                                  size="small"
                                  variant="outlined"
                                />
                              </TableCell>
                              <TableCell align="center">
                                <Box>
                                  <Typography variant="body2" fontWeight="bold">
                                    {rec.suggested_allocation || 100}%
                                  </Typography>
                                  <Typography variant="caption" color="text.secondary">
                                    ({rec.available_allocation || 0}% available)
                                  </Typography>
                                </Box>
                              </TableCell>
                              <TableCell align="center">
                                <Chip
                                  label={rec.priority || 'medium'}
                                  size="small"
                                  color={
                                    rec.priority === 'high' ? 'error' :
                                    rec.priority === 'medium' ? 'warning' :
                                    'default'
                                  }
                                  icon={<TrendingUpIcon />}
                                />
                              </TableCell>
                              <TableCell>
                                <Typography variant="body2" color="text.secondary">
                                  {rec.reasoning || 'No reasoning provided'}
                                </Typography>
                                {rec.current_projects > 0 && (
                                  <Typography variant="caption" color="warning.main" display="block" mt={0.5}>
                                    Currently on {rec.current_projects} project(s)
                                  </Typography>
                                )}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              ) : (
                <Alert severity="info" icon={<InfoIcon />}>
                  No suitable recommendations available at this time. 
                  {aiRecommendations?.availableEmployees === 0 
                    ? " All employees are fully allocated."
                    : " The AI couldn't find suitable candidates based on current project requirements."}
                </Alert>
              )}
            </>
          )}
        </DialogContent>
  
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button onClick={() => setShowRecommendations(false)} color="inherit">
            Close
          </Button>
          {hasRecommendations && (
            <Button 
              variant="contained" 
              onClick={applyAIRecommendations}
              disabled={selectedRecommendations.length === 0}
              startIcon={<AddIcon />}
            >
              Add Selected ({selectedRecommendations.length})
            </Button>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  return (
    <Container maxWidth="1500px" sx={{ py: 4 }}>
    <Paper elevation={3} sx={{ p: 4,  borderRadius: 2, // Rounded corners
  border: '2px solid',
  borderColor: 'grey.300', // Subtle professional border
  boxShadow: 4,  }}>
      <Typography variant="h4"  fontWeight="bold">
       Assign Team Members
      </Typography>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", my: 8 }}>
          <CircularProgress />
        </Box>
      ) : (
        <form onSubmit={handleSubmit}>
          <Paper sx={{ p: 3, mb: 4 }}>
            <Box display="flex" alignItems="center" mb={2}>
              <Typography variant="h6">Select Project/Product</Typography>
            </Box>
            <Divider sx={{ mb: 3 }} />

            <Grid container spacing={3}>
              <Grid item xs={12}>
              <FormControl fullWidth error={!!errors.selectedProject}>
  <InputLabel id="project-select-label">
    Project / Product
  </InputLabel>

  <Select
    labelId="project-select-label"
    id="project-select"
    value={teamData.selectedProject}
    onChange={handleProjectChange}
    label="Project / Product"
  >
    {projects.map((project) => (
      <MenuItem
        key={project.project_id}
        value={project.project_id}
      >
        {project.name} ({project.key})
      </MenuItem>
    ))}
  </Select>

  <FormHelperText>
    {errors.selectedProject}
  </FormHelperText>
</FormControl>
              </Grid>
            </Grid>

            {selectedProjectData && (
              <Box sx={{ mt: 3, p: 2.5, bgcolor: '#f8fafc', borderRadius: 2, border: '1px solid', borderColor: 'divider' }}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} md={4}>
                    <Typography variant="caption" color="text.secondary" fontWeight={700} display="block">
                      SELECTED PROJECT
                    </Typography>
                    <Typography variant="subtitle1" fontWeight={800} color="primary.main">
                      {selectedProjectData.name} ({selectedProjectData.key})
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography variant="caption" color="text.secondary" fontWeight={700} display="block">
                      PRODUCT MANAGER
                    </Typography>
                    <Chip 
                      label={getEmployeeNameById(selectedProjectData.product_manager_id) || "Unassigned"} 
                      size="small" 
                      color="primary" 
                      variant="outlined" 
                      sx={{ fontWeight: 700, mt: 0.5 }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography variant="caption" color="text.secondary" fontWeight={700} display="block">
                      PRODUCT OWNER
                    </Typography>
                    <Chip 
                      label={getEmployeeNameById(selectedProjectData.product_owner_id) || "Unassigned"} 
                      size="small" 
                      color="info" 
                      variant="outlined" 
                      sx={{ fontWeight: 700, mt: 0.5 }}
                    />
                  </Grid>
                </Grid>
              </Box>
            )}
            
            {isLoadingExistingData && (
              <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
                <CircularProgress size={24} />
                <Typography variant="body2" sx={{ ml: 1 }}>Loading existing team data...</Typography>
              </Box>
            )}
          </Paper>

          <Paper sx={{ p: 3, mb: 4 }}>
            <Box display="flex" alignItems="center" mb={2}>
              <Typography variant="h6">Select Team</Typography>
            </Box>
            <Divider sx={{ mb: 3 }} />

            <Grid container spacing={3}>
              <Grid item xs={12}>
               <FormControl fullWidth>
  <InputLabel id="team-select-label">
    Team
  </InputLabel>

  <Select
    labelId="team-select-label"
    id="team-select"
    value={selectedTeam}
    onChange={handleTeamChange}
    disabled={teams.length === 0}
    label="Team"
  >
    {teams.length > 0 ? (
      teams.map((team) => (
        <MenuItem
          key={team.team_id}
          value={team.team_id}
        >
          {team.team_name} - {team.team_type}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>
        No teams available
      </MenuItem>
    )}
  </Select>

  <FormHelperText>
    You can add members from multiple teams to this project
  </FormHelperText>
</FormControl>
              </Grid>
            </Grid>
            {/* <Box sx={{ mt: 2, display: 'flex', gap: 2, alignItems: 'center' }}> 
              <Button variant="contained" color="secondary"
               startIcon={loadingRecommendations ? <CircularProgress size={20} /> : <SparklesIcon />} 
               onClick={fetchAIRecommendations} disabled={!teamData.selectedProject || loadingRecommendations} 
               sx={{ background: 'linear-gradient(45deg, #667eea 30%, #764ba2 90%)', 
               boxShadow: '0 3px 5px 2px rgba(102, 126, 234, .3)', }} > 
            {loadingRecommendations ? 'Analyzing...' : 'Get AI Recommendations'} </Button>
             <Tooltip title="AI will analyze project requirements and suggest optimal team members"> 
              <IconButton size="small"> <InfoIcon /> </IconButton> </Tooltip> </Box> */}

            {teamMembers.length > 0 && (
              <>
                <Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }}>
                  Select team members from {getTeamNameById(selectedTeam)}:
                </Typography>
                <List>
                  {teamMembers.map((member) => {
                    // Check if this member is already assigned
                    const isAlreadyAssigned = teamData.assignedMembers.some(
                      m => m.employeeId === member.employee_id
                    );
                    
                    return (
                      <ListItem key={member.employee_id} dense button disabled={isAlreadyAssigned}>
                        <ListItemIcon>
                          <Checkbox
                            edge="start"
                            checked={selectedTeamMembers.includes(member.employee_id)}
                            tabIndex={-1}
                            disableRipple
                            onChange={() => handleTeamMemberSelect(member.employee_id)}
                            disabled={isAlreadyAssigned}
                          />
                        </ListItemIcon>
                        <ListItemText 
                          primary={
                            <Box display="flex" alignItems="center" gap={1}>
                              <Typography variant="body2" fontWeight={600}>
                                {getEmployeeNameById(member.employee_id)} ({member.role || 'Developer'})
                              </Typography>
                              {member.totalAllocation >= 100 ? (
                                <Chip label="🔴 Fully Occupied (100% Busy)" size="small" color="error" variant="outlined" />
                              ) : member.totalAllocation > 0 ? (
                                <Chip label={`🟡 ${100 - (member.totalAllocation || 0)}% Available`} size="small" color="warning" variant="outlined" />
                              ) : (
                                <Chip label="🟢 Available (100% Free)" size="small" color="success" variant="outlined" />
                              )}
                            </Box>
                          }
                          secondary={isAlreadyAssigned ? "Already assigned to this project" : (member.totalAllocation >= 100 ? "Warning: Resource is 100% allocated across active projects" : "")}
                        />
                      </ListItem>
                    );
                  })}
                </List>
              </>
            )}

            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={handleAddSelectedTeamMembers}
              disabled={selectedTeamMembers.length === 0 || !selectedTeam}
              sx={{ mt: 2 }}
            >
              Add Selected Members
            </Button>
          </Paper>

          <Paper sx={{ p: 3, mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              Assigned Team Members
            </Typography>
            <Divider sx={{ mb: 3 }} />

            {teamData.assignedMembers.length > 0 ? (
              <>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Team Member</TableCell>
                        <TableCell>Team</TableCell>
                        <TableCell>Role</TableCell>
                        <TableCell>Start Date</TableCell>
                        <TableCell>End Date</TableCell>
                        <TableCell>Allocation (%)</TableCell>
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {teamData.assignedMembers.map((member) => (
                        <TableRow key={member.employeeId}>
                          <TableCell>
                            {getEmployeeNameById(member.employeeId)}
                            {member.isExisting && (
                              <Chip 
                                size="small" 
                                label="Existing" 
                                color="primary" 
                                variant="outlined" 
                                sx={{ ml: 1, fontSize: '0.625rem' }}
                              />
                            )}
                          </TableCell>
                          <TableCell>
                            {getTeamNameById(member.teamId)}
                          </TableCell>
                          <TableCell>{member.role}</TableCell>
                          <TableCell>
                            <TextField
                              type="date"
                              value={member.startDate || ""}
                              onChange={(e) => handleMemberFieldChange(member.employeeId, "startDate", e.target.value)}
                              inputProps={{ min: dateConstraints.min, max: member.endDate || dateConstraints.max }}
                              onKeyDown={(e) => e.preventDefault()} 
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              type="date"
                              value={member.endDate || ""}
                              onChange={(e) => handleMemberFieldChange(member.employeeId, "endDate", e.target.value)}
                              inputProps={{ min: member.startDate || dateConstraints.min, }}
                              onKeyDown={(e) => e.preventDefault()} 
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              type="number"
                              value={member.allocation || 100}
                              onChange={(e) => handleMemberFieldChange(member.employeeId, "allocation", e.target.value)}
                              inputProps={{ min: 10, max: 100, step: 10}}
                              onKeyDown={(e) => e.preventDefault()}
                            />
                          </TableCell>
                          <TableCell>
                            <IconButton 
                              color="error" 
                              onClick={() => handleRemoveMember(member)}
                              title={member.isExisting ? "Delete from database" : "Remove from list"}
                            >
                              <DeleteIcon />
                            </IconButton>
                            <IconButton 
                              color="primary" 
                              onClick={() => handleEditMember(member)}
                              title="Edit team member role"
                            >
                              <EditIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            ) : (
              <Typography variant="body1" color="text.secondary" align="center" sx={{ py: 3 }}>
                {isLoadingExistingData 
                  ? "Loading team allocations..." 
                  : "No team members assigned yet. Please select members from the team above."}
              </Typography>
            )}
            {errors.assignedMembers && (
              <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                {errors.assignedMembers}
              </Typography>
            )}
          </Paper>

          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 4 }}>
            <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={() => navigate("/manageteam")}>
              Cancel
            </Button>
            <Button 
              type="submit" 
              variant="contained" 
              color="primary" 
              disabled={saving || isLoadingExistingData}
            >
              {saving ? <CircularProgress size={24} /> : "Save Team"}
            </Button>
          </Box>
        </form>
      )}

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={handleCloseDeleteDialog}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title" sx={{ display: 'flex', alignItems: 'center' }}>
          <WarningIcon color="warning" sx={{ mr: 1 }} />
          Delete Team Member
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            Are you sure you want to permanently remove this team member from the project?
            {memberToDelete?.employeeId && (
              <Box component="span" sx={{ fontWeight: 'bold', display: 'block', mt: 1 }}>
                Employee: {getEmployeeNameById(memberToDelete.employeeId)}
              </Box>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">
            Cancel
          </Button>
          <Button 
            onClick={handleDeleteMemberFromDB} 
            color="error" 
            variant="contained"
            disabled={deleting}
            startIcon={deleting ? <CircularProgress size={20} /> : <DeleteIcon />}
          >
            {deleting ? "Deleting..." : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity={snackbarSeverity} onClose={() => setSnackbarOpen(false)}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
      {AIRecommendationsDialog()}
  </Paper>
  </Container>
  );
};

export default TeamAllocation;